import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPuestoAsociado, getPuestos, removePuestosAsociados } from "../../../../redux/actions/resolucion";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import PuestosAsociadosForm from "./PuestosAsociadosForm";
import PuestosAsociadosTable from "./PuestosAsociadosTable";

const initialValues = {
  sustancia: null,
  nombreSustancia: "",
  nombrePuesto: "",
  puesto: "",
  descripcionActividades: "",
  descripcionEstudios: "",
  informaRiesgos: false,
  poseeCapacitaciones: false,
  entregaProteccion: false,
  licenciasEspeciales: false,
  elementosDeProteccion: [],
  medidasPreventivas: [],
};

const PuestosAsociadosContainer = ({ handleCancelResolucion, nextForm }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.resolucion.postResolucion.puestos);
  const sustancias = useSelector((state) => state.resolucion.postResolucion.sustancias);
  const trabajadores = useSelector((state) => state.resolucion.postResolucion.trabajadores);
  const puestos = useSelector((state) => state.resolucion.puestos.data);
  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  const [editingRow, setEditingRow] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [openDeletePuestosWarning, setOpenDeletePuestosWarning] = useState(false);
  const [puestosToDelete, setPuestosToDelete] = useState(null);

  useEffect(() => {
    dispatch(getPuestos(idDependenciaEmpleador));
  }, [])

  const handleOpenFormularioPuesto = (row) => {
    setEditingRow(row);
    setShowForm(true);
  };

  const handleDeletePuestos = () => {
    dispatch(removePuestosAsociados(puestosToDelete));
    setOpenDeletePuestosWarning(false);
  }

  const handleDelete = (rows) => {
    // solo mostrar el warning si hay algun examen guardado
    if (trabajadores.some((t) => rows.find((puesto) => puesto.puesto === t.idPuesto && Object.hasOwn(t?.examenes, `${puesto.sustancia}`)))) {
      setPuestosToDelete(rows);
      setOpenDeletePuestosWarning(true);
    } else {
      dispatch(removePuestosAsociados(rows));
    }
  };

  const handleSubmit = (values) => {
    dispatch(addPuestoAsociado(values, values?.index));
    setShowForm(false);
  };

  return (
    <div>
      {showForm ? (
        <PuestosAsociadosForm
          initialValues={editingRow || initialValues}
          onSubmit={handleSubmit}
          onCancel={() => setShowForm(false)}
          sustancias={sustancias.map((s) => ({ nombre: s.sustancia.nombre + ' - ' + s.sustancia.descripcionAgente, id: s?.id }))}
          puestos={puestos}
        />
      ) : (
        <PuestosAsociadosTable
          data={data}
          handleOpenFormularioPuesto={handleOpenFormularioPuesto}
          handleDelete={handleDelete}
          handleCancelResolucion={handleCancelResolucion}
          handleNext={() => nextForm('TrabajadoresSector')}
        />
      )}

      <ConfirmDialog
        open={openDeletePuestosWarning}
        handleClose={() => setOpenDeletePuestosWarning(false)}
        handleConfirm={handleDeletePuestos}
        title={"Eliminar Puestos"}
        warningText={"Algunos puestos tienen examenes asociados a sustancias ¿Seguro que desea eliminarlos?."}
      />
    </div>
  );
};

export default PuestosAsociadosContainer;
